export const SET_ABSOLUTE_SESSION_TIMEOUT_FLAG =
  'SET_ABSOLUTE_SESSION_TIMEOUT_FLAG';

export const setAbsoluteSessionTimoutFlagData = (data) => ({
  type: SET_ABSOLUTE_SESSION_TIMEOUT_FLAG,
  data: data,
});
